export const cardStyles = (theme) => ({
  card: {
    //margin:10,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      minHeight: '70px',
      height: '70px',
    },
  },
  cardHeader: {
    fontFamily: 'Flanders Art Sans!important',
    backgroundColor: '#f3f3f3',
    color: '#fff',
    textAlign: 'left',
    height: '100%',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      padding: '0!important',
    },
  },
  cardHeaderLink: {
    fontFamily: 'Flanders Art Sans!important',
    backgroundColor: '#f3f3f3',
    color: '#fff!important',
    textAlign: 'left',
    '&:hover': {
      color: '#bbb!important',
    },
    fontWeight: '400!important',
  },
});
